import classNames from "classnames";
import { ReactNode } from "react";

const SidebarFooter = ({
  children,
  hasTopBorder = true,
}: {
  children: ReactNode;
  hasTopBorder?: boolean;
}) => {
  return (
    <div
      className={classNames("SidebarFooter", {
        "SidebarFooter__topBorder--removed": !hasTopBorder,
      })}
    >
      {children}
    </div>
  );
};

export default SidebarFooter;
